import React, { useState, useEffect } from "react";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { TextField } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";;
import dayjs from 'dayjs';
import { addBanner, editBanner, getCompanyTypes, uploadBanner } from "../../../redux/bannerItemSlice";
import { Formik, Field, Form } from "formik";
import { useNavigate } from "react-router-dom";
import './styles.css'
import * as yup from 'yup';
import BannerPopup from "./BannerPopUp";
import SuccessModal from "../../../components/Modals/SuccessfulModal";
import toast from "react-hot-toast";

export const BANNER_VALIDATOR = yup.object().shape({
    bannerHeader: yup.string().required('Banner Header cannot be empty.'),
    bannerText: yup.string().required('Description is required.'),
    startTime: yup.date().required('Order date is required.'),
    endTime: yup.date().required('Order due date is required.'),
});


const BannerForm = ({ banner, action }) => {
    const [companyTypeId, setCompanyTypeId] = useState([])
    const [isAllVCPChecked, setIsAllVCPChecked] = useState(false)
    const [bannerData, setBannerData] = useState({
        bannerId: banner.bannerId,
        bannerHeader: banner.bannerHeader,
        bannerText: banner.bannerText,
        startTime: dayjs(banner.startTime).format('YYYY-MM-DD'),
        endTime: dayjs(banner.endTime).format('YYYY-MM-DD'),
        companyTypeId: banner.companyTypeId,
        isVisibleToAll: 0,
        bannerImagePath: banner.bannerImagePath
    })

    var allowedExtensions = /(\.jpg|\.jpeg|\.png|\.mp4)$/i;
    const [bannerImagePath, setBannerImagePath] = useState(banner.bannerImagePath)
    const imageUrl = 'http://localhost:3200/' + bannerImagePath // TODO TEMPORARY IMAGE UPLOAD 
    const [error, setError] = useState(false)
    const [errorMessage, setErrorMessage] = useState("")
    const [imageLoading, setImageLoading] = useState(true)
    const [companies, setCompanies] = useState(bannerData.companyTypeId)
    const [companyError, setCompanyError] = useState("")
    const [imageError, setImageError] = useState("")
    const [dateError, setDateError] = useState("")
    const [success, setSuccess] = useState(false)
    const [buttonDisabled, setButtonDisabled] = useState(true)
    const navigate = useNavigate()
    const [file, setFile] = useState("");
    const [fileUrl, setFileUrl] = useState("")

    const [show, setShow] = useState(false);
    const handleShow = () => setShow(true);

    const handleImageChange = (e) => {
        if (e.target.files[0]) {
            setFileUrl(URL.createObjectURL(e.target.files[0]));
            setFile(e.target.files[0])
        }
        setButtonDisabled(false)
    }

    const handleAllVCPChecked = (e) => {
        setIsAllVCPChecked(e.target.checked)
        if (e.target.checked) {
            let temp = companyTypeId.map((c) => c.companyTypeId)
            setCompanies(temp)
        } else {
            setCompanies([])
        }
    }

    const handleChecked = (e) => {
        const { checked, value } = e.target
        if (checked) {
            setCompanies((companies) => [...companies, parseInt(value)])
        }
        if (!checked) {
            setCompanies((companies) => companies.filter((c) => c != value))
        }

    }
    const handleImageUpload = async (event) => {
        event.preventDefault()
        setImageLoading(true)
        const formData = new FormData()
        formData.append("image", file)
        try {
            const result = await uploadBanner(formData)
            setBannerImagePath(result.data.filePath)
            setError(false)
            toast.success("Image Upload Success")
            setImageError("")
            setErrorMessage("")
        }
        catch (err) {
            toast.error("Image Upload Failed")
            setError(true)
            setErrorMessage(err.response.data.msg)
        }
        setImageLoading(false)
    }

    const handleBannerSubmit = async (values) => {
        if (companies.length == 0) {
            setCompanyError("Please Select Some VCP")
            return
        }
        if (bannerImagePath == "") {
            setImageError("Please Upload an Image")

        }
        values.companyTypeId = companies
        values.bannerImagePath = bannerImagePath

        if (new Date(values.startTime).getTime() > new Date(values.endTime).getTime()) {
            setDateError("From Date cannot be greater than To Date")
            return
        }

        if (action == 'Update') {
            try {
                await editBanner(values)
                setSuccess(true)
            } catch (err) {
                setError(true)
                setErrorMessage(err.response.data.msg)
            }
        }
        else {
            try {
                await addBanner(values)
                setSuccess(true)
            } catch (err) {
                setError(true)
                setErrorMessage(err.response.data.msg)
            }
        }

    }

    useEffect(() => {
        const getCompany = async () => {
            const data = await getCompanyTypes()
            setCompanyTypeId(data.data)
        }
        getCompany()
    }, [])

    return (
        <Formik
            initialValues={bannerData}
            enableReinitialize
            validationSchema={BANNER_VALIDATOR}
            onSubmit={(values, { setSubmitting, resetForm }) => {
                const formattedValues = {
                    ...values,
                    startTime: dayjs(values.startTime).format('YYYY-MM-DD'),
                    endTime: dayjs(values.endTime).format('YYYY-MM-DD'),
                };
                handleBannerSubmit(formattedValues)
            }}
        >{({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue
        }) =>
        (<Form onSubmit={handleSubmit}>
            <div className="banner_padding">
                <p className="banner_heading_text">Banner Heading</p>
                <TextField type="text" style={{
                    width: '100%',
                    background: '#fafafa',
                }} name="bannerHeader"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.bannerHeader}
                />
                {errors.bannerHeader && touched.bannerHeader ? (
                    <div className="" style={{ color: 'red' }}>{errors.bannerHeader}</div>
                ) : null}
            </div>
            <div className="banner_padding">
                <p className="banner_heading_text"> Valid till</p>
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between'
                }}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            className="date_form"
                            label="From Date"
                            name="startTime"
                            onChange={(newValue) => {
                                setFieldValue('startTime', newValue);
                            }}
                            defaultValue={banner.startTime !== '' ? dayjs(banner.startTime) : null}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                />
                            )}
                        />
                        {errors.startTime && touched.startTime ? (
                            <div className=" text-warning">Please select start time</div>
                        ) : null}
                    </LocalizationProvider>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DatePicker
                            className="date_form"
                            label="To Date"
                            name="endTime"
                            onChange={(newValue) => {
                                setFieldValue('endTime', newValue);
                            }}
                            defaultValue={banner.endTime !== '' ? dayjs(banner.endTime) : null}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                />
                            )}
                        />
                        {errors.endTime && touched.endTime ? (
                            <div className=" text-warning">Please select end time</div>
                        ) : null}
                    </LocalizationProvider>
                </div>
                {dateError.length > 0 ? <div style={{ color: 'red' }}>{dateError}</div> : null}
            </div>
            <div className="banner_padding">
                <p className="banner_heading_text">Featured Image</p>
                <input type="file" onChange={handleImageChange} />
                <img src={fileUrl.length > 0 ? fileUrl : imageUrl} accept="image/*" alt="" style={{
                    width: '80px',
                    height: '68px',
                    borderRadius: '12px',
                    marginLeft: '25px',
                    marginRight: '25px'
                }} />
                <button
                    type="submit"
                    disabled={buttonDisabled}
                    className={!buttonDisabled ? "btn btn-primary greeen-btn md_btn" : "btn btn-secondary md_btn"} style={{
                        margin: "10px",
                        width: '116px'
                    }}
                    onClick={handleImageUpload}>
                    <span><i className="mdi mdi-plus-circle-outline"></i>Upload</span>
                </button>
                {!imageLoading ? (error ? <div style={{ color: 'red' }}>{errorMessage}</div> : <div className="text-success">Upload Success</div>)
                    : <div></div>}
                {imageError.length > 0 ? <div style={{ color: 'red' }}>{imageError}</div> : null}
            </div>
            <div className="banner_padding">
                <p className="banner_heading_text">Description</p>
                <TextField
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.bannerText}
                    multiline
                    rows={8}
                    name="bannerText"
                    style={{
                        width: '100%',
                        background: '#fafafa',
                    }} />
                {errors.bannerText && touched.bannerText ? (
                    <div style={{ color: 'red' }}>{errors.bannerText}</div>
                ) : null}
            </div>
            <div className="banner_padding">
                <p className="banner_checkbox_heading">Banner Visibility</p>
                <div style={{
                    paddingBottom: '20px'
                }}><span style={{
                    padding: '5px'
                }}><input type="checkbox" onChange={handleAllVCPChecked} /></span>Visible to All VCP</div>
                <div className="banner_checkbox">
                    {companyTypeId.map((company) => (
                        <div key={company.companyTypeId}>
                            <div><span style={{
                                padding: '5px'
                            }}><input type="checkbox" disabled={isAllVCPChecked} defaultChecked={banner.companyTypeId.includes(company.companyTypeId)} onChange={handleChecked} value={company.companyTypeId} /></span>{company.companyTypeName}</div>
                        </div>
                    ))}
                </div>
                {companyError.length > 0 ? <div className=" text-warning">{companyError}</div> : null}
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between'
                }}>
                    <button className="btn btn-light grey-btn md_btn" style={{
                        margin: "10px",
                        width: '116px'
                    }} onClick={() => navigate("../banners")}
                    > <span><i className="mdi mdi-plus-circle-outline"></i>Back</span>
                    </button>
                    <button type="button" className="btn btn-primary greeen-btn md_btn" style={{
                        margin: "10px",
                        width: '116px'
                    }}
                        onClick={handleShow}
                    > <span><i className="mdi mdi-plus-circle-outline"></i>Preview</span>
                    </button>
                    <button
                        type="submit"
                        className="btn btn-primary greeen-btn md_btn" style={{
                            margin: "10px",
                            width: '116px'
                        }}>
                        <span><i className="mdi mdi-plus-circle-outline"></i>{action}</span>
                    </button>
                    <BannerPopup show={show} banner={values} imageUrl={imageUrl} handleShow={setShow} />
                </div>
                {error ? <div>{errorMessage}</div> : null}
                {success &&
                    <SuccessModal
                        isOpen={success}
                        msg={`Banner ${action} Successfully`}
                        navigatePage={'/banners'}
                    />}
            </div>
        </Form>)}
        </Formik>
    )
}

export default BannerForm